// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"728749bf49321c32ce8e","245":"44db81fdf74604303f3e","452":"8c48d77cc657590c7097","453":"6acfa280470699fe1568"}[chunkId] + ".js";
};